module.exports = __webpack_public_path__ + "static/snapshot.8af33446.png";